import cn from 'classnames';
import { useRootSelector } from '../../../../../../../store/hooks';
import { selectSitePricingProductsData } from '../../../../../store/features/products';
import { PricingPackagesFormValues } from '../../../../../store/features/packages/types';
import { MuiStack } from '../../../../../../../modules/material';
import Typography from '../../../../../shared/library/Typography';
import Paper from '../../../../../shared/library/Paper';
import RadioGroupField, {
  RadioGroupFieldProps,
} from '../../../../../shared/formElements/RadioGroupField';
import Radio from '../../../../../shared/library/Radio';

export interface VerticalTabsProps
  extends Pick<
    RadioGroupFieldProps<PricingPackagesFormValues>,
    'onChange' | 'className'
  > {}

export default function VerticalTabs(props: VerticalTabsProps) {
  const { onChange, className } = props;

  const { delegateTypes } = useRootSelector(selectSitePricingProductsData);

  return (
    <RadioGroupField
      name="delegateTypeId"
      onChange={onChange}
      className={cn(className, 'informa-payment-delegates-vertical')}
    >
      <MuiStack spacing={1}>
        {delegateTypes.map(({ delegateTypeId, name, description }) => {
          return (
            <Paper key={delegateTypeId}>
              <Radio
                value={delegateTypeId}
                label={
                  <MuiStack ml={1} spacing={1}>
                    <Typography
                      variant="featuredText"
                      className="informa-payment-delegates-vertical__name"
                    >
                      {name}
                    </Typography>
                    {description && (
                      <Typography
                        variant="smallText"
                        className="informa-payment-delegates-vertical__description"
                      >
                        {description}
                      </Typography>
                    )}
                  </MuiStack>
                }
              />
            </Paper>
          );
        })}
      </MuiStack>
    </RadioGroupField>
  );
}
